// extracted by mini-css-extract-plugin
export var centered = "Table-module--centered--da452";
export var container = "Table-module--container--954cf";
export var heading = "Table-module--heading--3f9ae";
export var item = "Table-module--item--1901b";
export var sortIcon = "Table-module--sortIcon--2a85f";
export var table = "Table-module--table--16e6f";
export var thresholdDisclaimer = "Table-module--thresholdDisclaimer--f36aa";
export var totalTesters = "Table-module--totalTesters--5ca06";